/**
 * Created by Victor Rojo on 6/11/19.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import {TankDeliveryNote} from "./TankDeliveryNote";

@Injectable()
export class TankDeliveryNoteService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    if ( error.error && this.isJson(error.error) ) {
      return Promise.reject(JSON.parse(error.error));
    }
    return Promise.reject(error.message || error);
  }

  private isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

  get(iPlaceIds:string, start:number, end:number): Promise<any>{
    let url = this.basePath + "tank_delivery_note";
    let params = new HttpParams();
    params = params.append('iPlaceIds', iPlaceIds)
      .append('startDate', start.toString())
      .append('endDate', end.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as TankDeliveryNote[])
      .catch( error => this.errorHandler(error) );
  }

  create(tankDeliveryNote:TankDeliveryNote){
    let url = this.basePath + "tank_delivery_note";
    return this.http.post(url,tankDeliveryNote, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }
}
